import { render, staticRenderFns } from "./SectionCreate.vue?vue&type=template&id=24077d45"
import script from "./SectionCreate.vue?vue&type=script&lang=js"
export * from "./SectionCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports